import React, { useEffect } from 'react';
import { META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE } from './data/content';
import { bonusCovers, heroMockupUrl, offerMockupUrl, pageImages } from './data/images';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { BeforeAfter } from './components/BeforeAfter';
import { MeetingSelector } from './components/MeetingSelector';
import { LookInsideSection } from './components/LookInsideSection';
import { SolutionSection } from './components/SolutionSection';
import { LevelsSection } from './components/LevelsSection';
import { YearPlanSection } from './components/YearPlanSection';
import { MeetingsList } from './components/MeetingsList';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const pixelNoscript = META_PIXEL_ID ? `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />` : '';
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div id="top" className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="3dii4aymltu1i">
      {pixelNoscript && <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="su45bjsmf6ga" />}
      <TopBar data-id="element-2" data-mp="swgkjp6zv2pn" />
      <main data-id="element-3" data-mp="36859fxwiety">
        <Hero heroMockupUrl={heroMockupUrl} data-id="element-4" data-mp="35yo8huu3i0e" />
        <StatsBand data-id="element-5" data-mp="34nb3rfi0xwm" />
        <BeforeAfter data-id="element-6" data-mp="38b6yx8f1wei" />
        <MeetingSelector data-id="element-7" data-mp="3ud1e95yxri91" />
        <LookInsideSection pageImages={pageImages} data-id="element-8" data-mp="3ubrhql7qei4i" />
        <SolutionSection data-id="element-9" data-mp="d4nxjm8nzu51" />
        <LevelsSection data-id="element-10" data-mp="d57dixer88gf" />
        <YearPlanSection data-id="element-11" data-mp="d3cvprys4wgk" />
        <MeetingsList data-id="element-12" data-mp="d2l936n5u92f" />
        <BonusesSection bonusCovers={bonusCovers} data-id="element-13" data-mp="85l1granwy97" />
        <OfferSection offerMockupUrl={offerMockupUrl} data-id="element-14" data-mp="864a1hefaaak" />
        <GuaranteeSection data-id="element-15" data-mp="3gl4qtf87pwiz" />
        <FaqSection data-id="element-16" data-mp="3gmfvdh9hf8b5" />
        <FinalCta data-id="element-17" data-mp="3glwfs77b0w0a" />
      </main>
      <Footer data-id="element-18" data-mp="3bmbehq4nwbke" />
      <StickyCta data-id="element-19" data-mp="3bmjnv81ksyqu" />
    </div>;
}